import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const NationalId = () => {
    const { control } = useFormContextContact()

    return (
        <Controller
            control={control}
            name="nationalId"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Identifiant national"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Identifiant national"
                />
            )}
        />
    )
}

export default NationalId
